// extracted by mini-css-extract-plugin
export default {"strong":"ReviewTopicsList_strong__5EHE-","summary":"ReviewTopicsList_summary__Mo-7q","wysiwyg":"ReviewTopicsList_wysiwyg__JnpcO"};